import React from 'react';
import { Button } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

interface GuidanceButtonProps {
  guidanceOpen: boolean;
  onToggleGuidance: () => void;
  buttonText?: Field<string> | string;
}

const GuidanceButton: React.FC<GuidanceButtonProps> = ({
  guidanceOpen,
  onToggleGuidance,
  buttonText,
}) => {
  const renderLabel = () => {
    if (!buttonText) return 'Guidance';
    if (typeof buttonText === 'string') return buttonText;
    return <Text field={buttonText} />;
  };

  return (
    <Button
      variant="outlined"
      startIcon={<HelpOutlineIcon />}
      endIcon={
        <ExpandMoreIcon
          sx={{
            transform: guidanceOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s',
          }}
        />
      }
      onClick={onToggleGuidance}
      sx={{
        textTransform: 'none',
        borderColor: (theme: any) => theme.palette.themeColor?.main,
        color: (theme: any) => theme.palette.themeColor?.main,
        '&:hover': {
          borderColor: (theme: any) => theme.palette.themeColor?.main,
          backgroundColor: (theme: any) => theme.palette.themeLightColor?.main,
        },
      }}
    >
      {renderLabel()}
    </Button>
  );
};

export default GuidanceButton;
